import {useScreenSize} from '@shared_web/lib/use_screen_size';

export enum Breakpoints {
  Mobile = 768, // 768px = mobile, 769px = tablet
  Desktop = 1024, // 1024px = tablet, 1025px = desktop
}

export const MEDIA_QUERY_MOBILE_ONLY = `@media (max-width: ${Breakpoints.Mobile}px)`;
export const MEDIA_QUERY_TABLET_ONLY = `@media (min-width: ${Breakpoints.Mobile + 1}px) and (max-width: ${Breakpoints.Desktop}px)`;
export const MEDIA_QUERY_DESKTOP_ONLY = `@media (min-width: ${Breakpoints.Desktop + 1}px)`;

export const MEDIA_QUERY_MOBILE_AND_TABLET = `(max-width: ${Breakpoints.Desktop}px)`;
export const MEDIA_QUERY_TABLET_AND_DESKTOP = `@media (min-width: ${Breakpoints.Mobile + 1}px)`;

export type ResponsiveType = 'mobile' | 'tablet' | 'desktop';

export function useResponsive(): {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  type: ResponsiveType;
} {
  const screenSize = useScreenSize();
  const isMobile = screenSize <= Breakpoints.Mobile;
  const isTablet = screenSize > Breakpoints.Mobile && screenSize <= Breakpoints.Desktop;
  const isDesktop = screenSize > Breakpoints.Desktop;
  const type = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
  return {
    isMobile,
    isTablet,
    isDesktop,
    type,
  };
}
